import { firebaseApp } from '@/shared/firebase/config';

export default function HealthPage() {
  return (
    <div className="min-h-full grid place-items-center p-6">
      <div className="card max-w-md w-full">
        <h1 className="text-lg font-bold mb-2">Estado</h1>
        <ul className="text-sm text-slate-700 space-y-1">
          <li>React: OK</li>
          <li>Tailwind: OK</li>
          <li>Firebase project: <code className="text-brand">{firebaseApp.options.projectId}</code></li>
        </ul>
      </div>
    </div>
  );
}
